import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import { FaFileExport } from "react-icons/fa"
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const AccountPayable = () => {
    const [data, setData] = useState([]);
    const [title, setTitle] = useState('Account Payable');
    const [pinnedBottomRowData, setPinnedBottomRowData]   = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const gridRef = useRef();
    const navigate = useNavigate();

    const fetchData = async () => {
        setIsLoading(true)
        try {
            const response = await Server.get('/account-payable/')
            
            setData(response?.data)
            setIsLoading(false) 

            const output = response?.data.reduce((data, row) => {
                data.debit += parseFloat(row.debit);
                data.credit += parseFloat(row.credit);
                return data;
            }, {debit: 0.00, credit: 0.00, balance: 0.00});
            setPinnedBottomRowData([
                {
                    credit: parseFloat(output.credit).toFixed(2),
                    debit: parseFloat(output.debit).toFixed(2),
                    balance: (output.credit - output.debit).toFixed(2),
                }
            ]);
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail)
            }
        }
    }

    useEffect(() => {
        
        fetchData()
    }, [])
    
    const [columnDefs] = useState([
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        {
            headerName: "Name",
            field: "name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Contact",
            field: "contact",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Credit",
            field: "credit",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Debit",
            field: "debit",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: "Balance",
            field: "balance",
            sortable: true,
            filter: 'agNumberColumnFilter',
        },
    ]);

    const onDoubleClick = (payload) => {
        navigate(`/account-payable-detail`, { state: {payload: payload}})
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
    
    const onExportClick=() => {
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    const getRowStyle = (params) => {
        if (params.node.rowPinned) {
          return {
            backgroundColor: '#f8f9fa',
            fontWeight: 'bold',
            color: '#000',
          };
        }
        return {};
    };

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="row">
            <div className="col-md-12">
                <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
            </div>
        </div>
        <div className="card mt-0">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{ title }</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            onRowDoubleClicked={(e) => {
                                if (e.node.rowPinned) return '';
                                if (e.data.customers < 1) return '';
                                
                                onDoubleClick({public_id: e.data.public_id, vendor: e.data.name})
                            }}

                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}
                            rowData={data}
                            domLayout={"normal"}
                            rowSelection={"multiple"}
                        
                            pagination={false}
                            onGridReady={onGridReady}
                        
                            resizable={true}
                            animateRows={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}
                        
                        
                            ref={gridRef}
                            pinnedBottomRowData={pinnedBottomRowData}
                            getRowStyle={getRowStyle}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
            </div>
        </div>
      <br/>
    </>
  )
}

export default AccountPayable